import React from 'react';
import '../../../../../less/mobile/index.less';
import { Control } from 'MWC';
import MenuItem from '../../../../../views/menuItem.c';
import arrowMobile from '../../../../../img/new/mobile/arrow-mobile.svg'
import cardsCard1 from '../../../../../img/new/cards-card-1-desktop.png'
import cardsCard2 from '../../../../../img/new/cards-card-2-desktop.png'
import cardsCard3 from '../../../../../img/new/cards-card-3-desktop.png'

export default function template() {

    const { active, navigate } = this.props;
    const {
        subMenuCards,
        subMenuCards2
    } = this.state

    let subMenuItem = (val, alias) => val.map((item, index) => {
          return <MenuItem
            active={active}
            alias={alias[index]}
            navigate={navigate}
            url={item.url}
            onClick={this.props.toggle}
          >
            {this.l10n(item.title)}
        </MenuItem>
    }
  )

  const alias1 = ['green', 'yellow', 'kid-card', 'premium', 'cards']
  const alias2 = ['eVidnovlennia', 'project-support', 'cashback_ua', 'diia']

    return (
        <div className="module-header-mobile__menu">
            <div className="module-header-mobile__menu__content">
                <Control>
                    <div className="module-header-mobile__menu__back__row">
                      <MenuItem
                          active={active}
                          alias="main"
                          navigate={navigate}
                          url="/"
                          onClick={this.props.changeMenu('main')}
                      >
                         <div className="module-header-mobile__menu__back" >
                              <img src={arrowMobile} alt="arrow back" />
                              {this.l10n('HEADER_LINK_BACK_CARDS')}
                          </div>
                      </MenuItem>
                    </div>
                    <div className="module-header-mobile__menu__content__main__top__input">
                      <input type="text" onClick={() => window.open('/search', '_self')} placeholder={this.l10n('NEW_HEADER_INPUT_PLACEHOLDER')}/>
                    </div>
                    <div className='header-menu-banners-side'>
                      <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_RECOMMENDED_PROPOSAL')}</div>
                      <div className="header-menu-banner-small">
                        <div className='left-side'>
                            <a id='cards-header-link-first' href="/cards/atb" style={{width: 120, height: 80}}>
                                <img src={cardsCard1} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                            </a>
                        </div>
                        <div className='right-side'>
                            <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_ATB_TITLE')}</div>
                            <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_ATB_SUBTITLE')}</div>
                        </div>
                      </div>
                      <div className="header-menu-banner-small">
                        <div className='left-side'>
                            <a id='cards-header-link-second' href="/cards/bolt" style={{width: 120, height: 80}}>
                                <img src={cardsCard2} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                            </a>
                        </div>
                        <div className='right-side'>
                            <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_BOLT_TITLE')}</div>
                            <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_BOLT_SUBTITLE')}</div>
                        </div>
                      </div>
                      <div className="header-menu-banner-small">
                        <div className='left-side'>
                            <a id='cards-header-link-second' href="/cards/vygoda" style={{width: 120, height: 80}}>
                                <img src={cardsCard3} alt="" className='header-menu-banner-small-img' style={{width: 120, height: 80}}/>
                            </a>
                        </div>
                        <div className='right-side'>
                            <div className='right-side-title'>{this.l10n('NEW_HEADER_CARDS_VYGODA_TITLE')}</div>
                            <div className='right-side-subtitle'>{this.l10n('NEW_HEADER_CARDS_VYGODA_SUBTITLE')}</div>
                        </div>
                      </div>
                    </div>
                    <div style={{marginBottom: 32}}>
                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_MAIN_CARDS')}</div>
                      {subMenuItem(subMenuCards, alias1)}
                    </div>
                    <div>
                    <div className='header-menu-subtitle'>{this.l10n('NEW_HEADER_CARDS_GOV_PROGRAMS')}</div>
                      {subMenuItem(subMenuCards2, alias2)}
                    </div>
                </Control>

            </div>
        </div>
    );
}
